import videojs from "video.js";

export default class LoopButton extends videojs.getComponent("Button") {
    constructor(player, options = {}) {
        super(player, options);

        this.addClass("vjs-loop-button");
        this.addClass("vjs-looping-on");
    }

    handleClick(e) {
        if (this.player_.loop()) {
            this.removeClass("vjs-looping-on");
            this.addClass("vjs-looping-off");
        } else {
            this.removeClass("vjs-looping-off");
            this.addClass("vjs-looping-on");
        }

        this.player_.loop(!this.player_.loop());
    }

    createEl(tag = "button", props, attributes) {
        const el = super.createEl(tag, props, attributes);
        el.innerHTML = "LOOP";
        return el;
    }
}



// WEBPACK FOOTER //
// ./app/lib/common/components/LoopButton.js